import { createSlice } from '@reduxjs/toolkit'
import { AppState } from 'store/slices/types'

const initialState = {
  isDarkMode: false,
  loadingMessage: '',
  isFormSubmitting: false,
  user: null,
  mobileDrawerOpen: false,
} as AppState

const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setDarkModeAction: (state, action) => {
      state.isDarkMode = action.payload
    },
    setMobileDrawerOpen: (state, action) => {
      state.mobileDrawerOpen = action.payload
    },
    setLoadingAction: (state, action) => {
      state.loadingMessage = action.payload
    },
    setFormSubmittingAction: (state, action) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const {
  setDarkModeAction,
  setLoadingAction,
  setFormSubmittingAction,
  setMobileDrawerOpen,
} = appSlice.actions
export default appSlice
